import { ChangeDetectionStrategy, Component, inject, Input } from "@angular/core";
import moment from "moment/min/moment-with-locales";
import { SharedModule } from "../../../../shared/shared.module";
import { LanguageService } from "app/shared";
import { Location, IncidentMedicationType, FoundMedicationIncident } from "../../../../shared/types";
import { FoundMedicationIncidentModel } from "../../services/found-medication-incident-model.service";

@Component({
	selector: "ic-found-medication-incident-summary",
	templateUrl: "./found-medication-incident-summary.component.html",
	styleUrls: ["./found-medication-incident-summary.component.scss"],
	imports: [SharedModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FoundMedicationIncidentSummaryComponent {
	private readonly languageService = inject(LanguageService);
	private readonly model = inject(FoundMedicationIncidentModel);

	// @ts-expect-error TS2564
	@Input() medicationIncident: FoundMedicationIncident;

	protected MedicationType = IncidentMedicationType;

	protected getLocationDescription(location: Location) {
		const parts = [
			location.departmentId &&
				this.model.departmentsOptions().find((department) => department.value === location.departmentId)?.label,
			location.roomId,
			location.description,
		].filter(Boolean);
		return parts.join(" - ");
	}

	protected formatDateTime(date: string) {
		return date && moment(date).locale(this.languageService.language()).format("dddd DD/MM/YYYY");
	}
}
